import { signal } from 'services/SignalsService'

signal.once('INIT:REGULAR', () => update(false))
signal.once('INIT:FREESPINS', () => update(true))

function init() {
  signal.on('STATE:IN:FS-ADD', check)
  signal.on('STATE:OUT:FS-END', () => update(false))
}

function update(value) {
  signal.dispatch('FREESPINS-MODE', value)
}

function check() {
  if (game.models.FreespinModel.get().left == game.models.FreespinModel.get().all) {
    update(true)
  }
}

export const FreespinsService = { init }
